// extracted by mini-css-extract-plugin
export default {"enabledContainer":"src-pages-SalesChannelProductsConfig-SalesChannelProductAlias-EditPage-Carousel-style-module__enabledContainer--UrVlX"};